export function valueOrThrow<T>(value?: T | null): T {
  if (value == undefined) {
    throw new Error("Expected element is undefined");
  }
  return value;
}

export function isEmptyOrNull(str: string | null | undefined): boolean {
  return !str || str.length === 0;
}

export function setSidetittel(tittel: string) {
  document.title = `${tittel} - Anmelde - Politiet.no`;
}

export function formatHtmlIdFromFieldPath(value: string) {
   
  return value.replaceAll(".", "-");
}

export const lagSetning = (tekst: string) => {
  return tekst.charAt(0).toUpperCase() + tekst.slice(1);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function replaceNullWithUndefined(obj: any): any {
  if (obj === null) return undefined;
  if (typeof obj === "string" && obj === "") return undefined;
  if (typeof obj !== "object" || obj === undefined) return obj;
  if (Array.isArray(obj)) return obj.map(replaceNullWithUndefined);
  if (typeof obj === "object") {
     
    const objectWithUndefined = Object.fromEntries(
      Object.entries(obj as object)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(([key, value]) => [key, replaceNullWithUndefined(value)])
        .filter(([, value]) => value !== undefined),
    ) as object;
    if (
      Object.values(objectWithUndefined).every((value) => value == undefined)
    ) {
      return undefined;
    } else {
      return objectWithUndefined;
    }
  }
  throw Error(
    `Could not run replaceNullWithUndefined for object of type ${typeof obj}, object: ${obj}`,
  );
}


/*
 * Funksjon for fjerne alle tegn som ikke er lovlige i XML 1.0 standarden.
 * Lovlige tegn:
 * 0x9, 0xA, 0xD = tab, line feed, carriage return
 * 0x20-0xD7FF = space to the end of the BMP before surrogates
 * 0xE000-0xFFFD = private use area to the end of BMP
 * 0x10000-0x10FFFF = supplementary characters outside the Basic Multilingual Plane
 */
export function removeInvalidCharacters(value: string): string {

  let result = "";
  for (const char of value) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const codePoint = char.codePointAt(0)!;
    if (
      codePoint === 0x09 ||
      codePoint === 0x0A ||
      codePoint === 0x0D ||
      (codePoint >= 0x20 && codePoint <= 0xD7FF) ||
      (codePoint >= 0xE000 && codePoint <= 0xFFFD) ||
      (codePoint >= 0x10000 && codePoint <= 0x10FFFF)
    ) {
      result += char;
    }
  }
  return result;
}

export function keepDigitsBeforeDecimalSeparator(value: string): string {
  const integerPart = value.split(/[.,]/, 1)[0];
  return integerPart.replace(/\D/g, "");
}
